/* eslint-disable @typescript-eslint/no-var-requires */
import React, { FunctionComponent, memo, SyntheticEvent } from 'react'
import './Image.scss'

interface FunctionComponentProps {
  src: string
  srcAvif?: string
  srcWebp?: string
  onError?(e?: SyntheticEvent<HTMLElement>): void
}

const Image: FunctionComponent<FunctionComponentProps> = ({ src, srcWebp, srcAvif, onError }) => (
  <picture className="Image" onError={(e) => onError?.(e)}>
    {srcAvif && <source srcSet={srcAvif} type="image/avif" />}
    {srcWebp && <source srcSet={srcWebp} type="image/webp" />}
    <img src={src} loading="lazy" />
  </picture>
)

export default memo(Image)
